/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListingStatusItemDto
 */
export interface ListingStatusItemDto {
    /**
     * Listing status ID
     * @type {number}
     * @memberof ListingStatusItemDto
     */
    id?: number;
    /**
     * Listing status name
     * @type {string}
     * @memberof ListingStatusItemDto
     */
    listingStatus: string;
}

/**
 * Check if a given object implements the ListingStatusItemDto interface.
 */
export function instanceOfListingStatusItemDto(value: object): value is ListingStatusItemDto {
    if (!('listingStatus' in value) || value['listingStatus'] === undefined) return false;
    return true;
}

export function ListingStatusItemDtoFromJSON(json: any): ListingStatusItemDto {
    return ListingStatusItemDtoFromJSONTyped(json, false);
}

export function ListingStatusItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingStatusItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'listingStatus': json['listingStatus'],
    };
}

export function ListingStatusItemDtoToJSON(json: any): ListingStatusItemDto {
    return ListingStatusItemDtoToJSONTyped(json, false);
}

export function ListingStatusItemDtoToJSONTyped(value?: ListingStatusItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'listingStatus': value['listingStatus'],
    };
}

